import script from "./xtx-bread.vue?vue&type=script&lang=js"
export * from "./xtx-bread.vue?vue&type=script&lang=js"

import "./xtx-bread.vue?vue&type=style&index=0&id=73af84d1&lang=less"

const __exports__ = script;

export default __exports__